import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const CardStyle = styled.div`
    label: Card;

    background-color: #fff;
    height: 400px;
    width: 300px;
    box-shadow: 0 0 20px grey;
    border-color: #ccc;
    border-style: solid;
    border-width: 1px;
    border-radius: 8px;
    text-align: center;

    /* Center slide text vertically */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 22px;
`;
const CardImage = styled.div`
    label: CardImage;

    & > img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
    }
`;
const CardTitle = styled.div`
    label: CardTitle;

    font-family: effra_bold, sans-serif;
    font-size: 16pt;
    font-weight: bold;
    color: #0796d8;
    padding: 5px;
`;
const CardDescription = styled.div`
    label: CardDescription;

    font-family: effra, sans-serif;
    font-size: 12pt;
    font-weight: lighter;
    color: #000;
    padding: 5px;
`;

const CardInfo = ({ active, image, title, description }) => (
    <CardStyle active={active}>
        <CardImage>
            <img src={image} alt={title} height={400} />
        </CardImage>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
    </CardStyle>
);

export const CardInfoPropTypes = {
    active: PropTypes.bool,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
};
CardInfo.propTypes = CardInfoPropTypes;
CardInfo.defaultProps = {};
export default CardInfo;
